/**
 * Executes function if user mouse down outside the HTML Element ref(s).
 *
 * Derived from ../../hooks/useOnOutsideMouseDown
 * Add mark event capability
 */

import { useEffect, RefObject } from 'react';
import cn from '../Modal/Modal.css.json';

const markedEvents = new WeakSet<Event>();

export function markEvent(event: Event) {
  markedEvents.add(event);
}

export function isEventMarked(event: Event) {
  return markedEvents.has(event);
}

export const useOnOutsideMouseDown = (
  containerRef:
    | RefObject<HTMLElement | null | undefined>
    | Array<RefObject<HTMLElement | null | undefined>>,
  onOutsideMouseDown: () => void
) => {
  useEffect(() => {
    const onMouseDown = (event: MouseEvent) => {
      if (isEventMarked(event)) return;

      const containerRefs = !Array.isArray(containerRef) ? [containerRef] : containerRef;

      for (const ref of containerRefs) {
        if (ref.current?.contains(<HTMLElement>event.target)) {
          return;
        }
      }

      const blockLayers = document.getElementsByClassName(cn.modalBlockLayer);
      if (blockLayers.length) {
        const topBlockLayer = blockLayers[blockLayers.length - 1];
        for (const ref of containerRefs) {
          if (ref.current && !topBlockLayer.contains(ref.current)) return;
        }
      }

      onOutsideMouseDown();
    };
    window.addEventListener('mousedown', onMouseDown);
    return () => {
      window.removeEventListener('mousedown', onMouseDown);
    };
  }, [containerRef, onOutsideMouseDown]);
};
